/* CC Leseprobe-Flipbook (Custom Element <cc-flipbook>)
 *
 * Mobile-Smoothness-Vertrag:
 * - Init erst in Viewport-Naehe (IntersectionObserver, 600px rootMargin)
 * - StPageFlip im HTML-Modus (loadFromHTML): DOM-Pages, keine Eager-Decodes
 * - Eigenes Preload-Fenster (aktuelle Seite -1..+3) statt loading=lazy,
 *   Decode via img.decode() im Idle - nie beim Flip selbst
 * - Slider-Fallback (CSS scroll-snap) bei prefers-reduced-motion,
 *   Init-Fehlern, weniger als 4 Seiten oder data-mode="slider"
 * - Kein Optional-Chaining/Nullish: Parse-Fehler auf Alt-Browsern wuerden
 *   auch den Fallback toeten (ES2017-Niveau reicht bis iOS 11 zurueck)
 */
(function () {
  'use strict';
  if (window.customElements && customElements.get('cc-flipbook')) return;

  var libPromise = null;
  function loadLib(src) {
    if (window.St && window.St.PageFlip) return Promise.resolve();
    if (!libPromise) {
      libPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = function () {
          libPromise = null;
          reject(new Error('cc-flipbook: Lib-Load fehlgeschlagen: ' + src));
        };
        document.head.appendChild(s);
      });
    }
    return libPromise;
  }

  function idle(fn) {
    if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 500 });
    else setTimeout(fn, 60);
  }

  class CCFlipbook extends HTMLElement {
    connectedCallback() {
      if (this.ccStarted) return; // Theme-Editor kann re-connecten
      this.ccStarted = true;
      this.pageFlip = null;
      // Slots (Seiten-Divs) zaehlen, nicht IMGs: ein Slot darf leer sein
      // (fehlendes preview_image), der Index-Kontrakt zum Metafeld bleibt
      this.pages = Array.prototype.slice.call(this.querySelectorAll('.cc-flipbook__page'));
      this.count = this.pages.length;
      this.reduced = window.matchMedia
        && matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setupToc();

      var useSlider = this.reduced
        || this.count < 4
        || this.dataset.mode === 'slider'
        || !('IntersectionObserver' in window);
      var self = this;
      if (!('IntersectionObserver' in window)) {
        this.initSlider();
        return;
      }
      this.observe(function () {
        if (useSlider) self.initSlider();
        else self.boot();
      });
    }

    disconnectedCallback() {
      if (this.io) { this.io.disconnect(); this.io = null; }
      // destroy() entfernt [data-book] samt Seiten unwiederbringlich.
      // Beim Re-Append desselben Elements (Editor-Reorder, App-Reparenting)
      // feuert disconnect+connect synchron - deshalb destroy nur, wenn das
      // Element im naechsten Tick wirklich draussen ist.
      var self = this;
      setTimeout(function () {
        if (self.isConnected) return;
        if (self.pageFlip) {
          try { self.pageFlip.destroy(); } catch (e) { /* editor unload */ }
          self.pageFlip = null;
        }
        self.ccStarted = false;
      }, 0);
    }

    observe(cb) {
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          self.io.disconnect();
          self.io = null;
          cb();
        }
      }, { rootMargin: '600px 0px' });
      this.io.observe(this);
    }

    setupToc() {
      var toc = this.querySelector('[data-toc]');
      if (!toc || !window.matchMedia) return;
      var mq = matchMedia('(min-width: 990px)');
      var sync = function () {
        // Desktop-Sidebar ist immer offen (Summary dort nicht klickbar),
        // mobil startet das Accordion zu
        if (mq.matches) toc.setAttribute('open', '');
        else toc.removeAttribute('open');
      };
      sync();
      if (mq.addEventListener) mq.addEventListener('change', sync);
      else if (mq.addListener) mq.addListener(sync);
    }

    pageSizes() {
      if (window.innerWidth >= 990) {
        return this.classList.contains('cc-flipbook--slider') ? '34rem' : '24rem';
      }
      return '88vw';
    }

    loadPage(i) {
      var slot = this.pages[i];
      var img = slot ? slot.querySelector('img') : null;
      if (!img || img.dataset.loaded) return Promise.resolve();
      img.dataset.loaded = '1';
      img.sizes = this.pageSizes();
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    }

    preload(cur) {
      var self = this;
      idle(function () {
        // -3..+3: Landscape-Rueckwaertsflip zeigt cur-2 waehrend der Animation
        for (var i = cur - 3; i <= cur + 3; i++) self.loadPage(i);
      });
    }

    boot() {
      var self = this;
      Promise.all([this.loadPage(0), this.loadPage(1), this.loadPage(2)])
        .then(function () { return loadLib(self.dataset.libSrc); })
        .then(function () {
          if (!(window.St && window.St.PageFlip)) throw new Error('St.PageFlip fehlt');
          self.initFlip();
        })
        .catch(function (err) {
          if (window.console) console.warn('cc-flipbook: Fallback auf Slider.', err);
          // Halb-initialisierten Flip aufraeumen: Seiten zurueck in [data-book],
          // sonst layoutet der Slider auf zerlegtem DOM
          if (self.pageFlip) {
            try {
              if (self.pageFlip.getUI && self.pageFlip.getUI().clear) self.pageFlip.getUI().clear();
            } catch (e2) { /* best effort */ }
            self.pageFlip = null;
          }
          self.initSlider();
        });
    }

    initFlip() {
      var ratio = parseFloat(this.dataset.ratio) || 0.715;
      var book = this.querySelector('[data-book]');
      if (!book) return;
      book.hidden = false;
      this.pageFlip = new St.PageFlip(book, {
        width: 500,
        height: Math.round(500 / ratio),
        size: 'stretch',
        minWidth: 280,
        maxWidth: 640,
        minHeight: Math.round(280 / ratio),
        maxHeight: Math.round(640 / ratio),
        usePortrait: true,
        showCover: true,
        flippingTime: 600,
        drawShadow: true,
        maxShadowOpacity: 0.35,
        mobileScrollSupport: true,
        swipeDistance: 24,
        showPageCorners: true,
        autoSize: true
      });
      this.pageFlip.loadFromHTML(this.querySelectorAll('.cc-flipbook__page'));
      this.removePlaceholder();
      var self = this;
      this.pageFlip.on('flip', function (e) {
        self.updateCounter(e.data);
        self.preload(e.data);
      });
      this.pageFlip.on('changeOrientation', function () {
        self.updateCounter(self.currentIndex());
      });
      this.preload(0);
      this.bindFlipControls();
      this.classList.add('cc-flipbook--ready');
    }

    currentIndex() {
      if (this.pageFlip && this.pageFlip.getCurrentPageIndex) {
        return this.pageFlip.getCurrentPageIndex();
      }
      return 0;
    }

    updateCounter(i) {
      var el = this.querySelector('[data-counter]');
      if (!el) return;
      var n = this.count;
      var landscape = false;
      if (this.pageFlip && this.pageFlip.getOrientation) {
        landscape = this.pageFlip.getOrientation() === 'landscape';
      }
      if (landscape && i > 0 && i + 2 <= n) {
        el.textContent = 'Seiten ' + (i + 1) + ' und ' + (i + 2) + ' von ' + n;
      } else {
        el.textContent = 'Seite ' + Math.min(i + 1, n) + ' von ' + n;
      }
    }

    bindFlipControls() {
      var self = this;
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.pageFlip.flipPrev(); });
      if (next) next.addEventListener('click', function () { self.pageFlip.flipNext(); });

      var stage = this.querySelector('[data-stage]');
      if (stage) {
        stage.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.pageFlip.flipPrev(); }
          if (e.key === 'ArrowRight') { e.preventDefault(); self.pageFlip.flipNext(); }
        });
      }

      Array.prototype.forEach.call(this.querySelectorAll('[data-goto]'), function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.dataset.goto, 10);
          if (isNaN(i)) return;
          // Zielseite + Nachbarn dekodieren, DANN animiert hinblaettern
          // (i-2: Landscape-Animation startet vom Spread davor)
          Promise.all([self.loadPage(i - 2), self.loadPage(i - 1), self.loadPage(i), self.loadPage(i + 1)])
            .then(function () {
              self.pageFlip.flip(i);
              self.preload(i);
            });
          if (stage && window.innerWidth < 990) {
            stage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      });
    }

    /* ---------- Slider-Fallback (scroll-snap, browser-composited) ---------- */

    removePlaceholder() {
      var ph = this.querySelector('[data-placeholder]');
      if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
    }

    initSlider() {
      if (this.sliderStarted) return;
      this.sliderStarted = true;
      var self = this;
      var book = this.querySelector('[data-book]');
      if (!book) return;
      this.classList.add('cc-flipbook--slider');
      // Nativer Lazy-Loader uebernimmt im Scroll-Flow
      this.pages.forEach(function (slot) {
        var img = slot.querySelector('img');
        if (!img) return;
        img.loading = 'lazy';
        img.sizes = self.pageSizes();
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.dataset.loaded = '1';
      });
      book.hidden = false;
      this.removePlaceholder();

      var pageWidth = function () { return book.clientWidth || 1; };
      var current = function () { return Math.round(book.scrollLeft / pageWidth()); };
      var goTo = function (i) {
        i = Math.max(0, Math.min(self.count - 1, i));
        book.scrollTo({ left: i * pageWidth(), behavior: self.reduced ? 'auto' : 'smooth' });
      };

      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      Array.prototype.forEach.call(this.querySelectorAll('[data-goto]'), function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.dataset.goto, 10);
          if (!isNaN(i)) goTo(i);
        });
      });

      var ticking = false;
      book.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          self.updateCounter(current());
          ticking = false;
        });
      }, { passive: true });
      this.updateCounter(0);
      this.classList.add('cc-flipbook--ready');
    }
  }

  if (window.customElements) customElements.define('cc-flipbook', CCFlipbook);
})();
